var React = require('react');

function LabTubeBottle (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("path",{"className":"a","d":"M15.75,7.5V3.75h4.5V21a2.252,2.252,0,0,1-3,2.122","key":1}),React.createElement("line",{"className":"a","x1":"21.75","y1":"3.75","x2":"14.25","y2":"3.75","key":2}),React.createElement("line",{"className":"a","x1":"6.75","y1":"0.75","x2":"12.75","y2":"0.75","key":3}),React.createElement("path",{"className":"a","d":"M11.25,8.4V.75h-3V8.4a7.5,7.5,0,1,0,3,0Z","key":4}),React.createElement("line",{"className":"a","x1":"17.1","y1":"17.25","x2":"2.4","y2":"17.25","key":5})]);
}

LabTubeBottle.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = LabTubeBottle;

LabTubeBottle.default = LabTubeBottle;



//////////////////
// WEBPACK FOOTER
// ./src/components/icon/svgs/lab-tube-bottle.svg
// module id = 1073
// module chunks = 0